module.exports = __webpack_public_path__ + "media/images/pla/pla6-ddf7cbeac6896d3c5b3b5d594ff5551c.jpg";